export const environment = {
  production: true,
  apiUrl: 'https://api-reimo.sreyesv.xyz/api',
  //apiUrl: 'http://localhost:8080/api',
  sseUrl: 'https://api-reimo.sreyesv.xyz/api/events',
  imagesUrl: 'https://reimo-app-images.s3.us-east-1.amazonaws.com/voluntarios',
  logosUrl: 'https://reimo-app-images.s3.us-east-1.amazonaws.com/logos',
  sseEnabled: true,
  bypassLogin: true,
  metaHorasMensual: 70,
  ApiKeyMapsSegunda: 'AIzaSyB5nI1SrnPkjuG7gTgo6r81xjW_dV0471Y'
};
